import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SensitiveRequestsInterceptor implements HttpInterceptor {
  private static readonly BODY_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];
  private static readonly NO_CACHE_HEADERS: Readonly<Record<string, string>> = {
    'Cache-Control': 'no-store, no-cache, must-revalidate, private, max-age=0',
    'Pragma': 'no-cache',
  };
  private static readonly SENSITIVE_ENDPOINTS = ['/auth', '/stammdaten', '/antraege', '/documents', '/users'];

  public intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const isSensitive = this.isSensitiveRequest(request.url);

    if (!isSensitive) {
      return next.handle(request);
    }

    return this.addSecurityHeaders<T>(request, next);
  }

  private isSensitiveRequest(url: string): boolean {
    return SensitiveRequestsInterceptor.SENSITIVE_ENDPOINTS.some((endpoint) => url.toLowerCase().includes(endpoint));
  }

  private addSecurityHeaders<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const contentTypeMissing = this.isContentTypeMissing<T>(request);
    const isBodyFormData = this.isFormData(request.body);

    if (!contentTypeMissing || isBodyFormData) {
      return next.handle(
        request.clone({
          setHeaders: {
            ...SensitiveRequestsInterceptor.NO_CACHE_HEADERS,
          },
        }),
      );
    }

    return next.handle(
      request.clone({
        setHeaders: {
          'Content-Type': 'application/json; charset=UTF-8',
          ...SensitiveRequestsInterceptor.NO_CACHE_HEADERS,
        },
      }),
    );
  }

  private isFormData(body: unknown): body is FormData {
    return typeof FormData !== 'undefined' && body instanceof FormData;
  }

  private isContentTypeMissing<T>(request: HttpRequest<T>): boolean {
    const methodAllowsBody = SensitiveRequestsInterceptor.BODY_METHODS.includes(request.method.toUpperCase());
    const hasBody = !!request.body;

    return methodAllowsBody && hasBody && !request.headers.has('Content-Type');
  }
}
